import React from 'react';
import 'react-image-gallery/build/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import defaultBannerImg from './images/banner.jpg';
import './style.css';

export default function ({ banners, showSetting, settingTooltip, carouselSecond = 10, isLoaded }) {
  if (!banners) {
    return '';
  }
  const bannerImages = banners.map((banner) => {
    let bannerLink = banner.languageLink ? banner.languageLink : '';
    if (bannerLink.length > 0 && /^(http|https):\/\//.test(banner.languageLink) === false) {
      bannerLink = `http://${bannerLink}`;
    }
    return {
      original: banner.uploadImageUrl,
      description: (
        bannerLink.length === 0 ? undefined : <a className="banner__link" href={bannerLink} target="_blank"/>
      ),
    };
  });

  if (bannerImages.length === 0 && isLoaded) {
    bannerImages.push({
      original: defaultBannerImg,
    });
  }

  return (
    <div className="banner clearfix">
      <ImageGallery
        items={bannerImages}
        showNav={false}
        showBullets
        showThumbnails={false}
        autoPlay
        slideInterval={ carouselSecond * 1000 }
      />
      {
        showSetting && (
          <a className="banner__setting" href="/Tu0501/NewsBannerManagement_zh_tw" title={settingTooltip}>
            <i className="fa fa-cogs"></i>
          </a>
        )
      }
    </div>
  );
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/components/banner/index.js
 **/